<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">P<span class="smallcaps">ART </span>O<span class="smallcaps">NE </span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// faith-fox_00004.vue?5e32f6f4